import React from 'react';
import { DataList } from 'commons-ui';

import { columnConfigs } from './listConfig';
import { makeActionHandler } from '../../actions/showChangesHandlers';
import { makeActionList } from '../../actions/showChangesList';

interface IShowChangesListProps {
	entity: string;
	usePageActions: any;
	getShowChangesData: () => void;
}

const ShowChangesList: React.FC<IShowChangesListProps> = (props) => {
	const { entity, usePageActions, getShowChangesData } = props;
	const { getActionHandler, getActionList } = usePageActions(makeActionHandler, makeActionList);
	const actions = getActionList();

	return (
		<DataList
			fetchData={getShowChangesData}
			columnConfigs={columnConfigs}
			getActionHandler={getActionHandler}
			actions={actions}
			rowHeight={100}
			entity={entity}
		/>
	);
};

export default ShowChangesList;
